module.exports = __webpack_public_path__ + "static/media/logo_white.7219bea2.png";